import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { Partners, KeyFigures } from "../components/site/Partners";
import { Verticals, Services, Process, Guarantees } from "../components/site/Sections";
import { Network } from "../components/site/ModelNetwork";
import { DiagnosticForm } from "../components/site/DiagnosticForm";
import { Footer } from "../components/site/Footer";
import { ProSpace } from "../components/pro/ProSpace";
import { Academy } from "../components/site/Academy";

const Hr = () => <hr className="divider" />;

export default function Home() {
  return (
    <>
      <a href="#main" className="skip-link">Skip to content</a>
      <Header />
      <main id="main">
        <Hero />
        <Partners />
        <KeyFigures />
        <Verticals /><Hr />
        <Services /><Hr />
        <Academy /><Hr />
        <Process /><Hr />
        <Guarantees /><Hr />
        <ProSpace /><Hr />
        <Network /><Hr />
        <DiagnosticForm />
      </main>
      <Footer />
    </>
  );
}
